/**
 * Focuses the passed element or selector.
 * @param {HTMLElement|string} target - DOM element or selector string.
 * @param {Object} options - { scroll: boolean }
 */
export function focusElement(target, options = {}) {
  const { scroll = false } = options;
  let el = target;

  if (typeof target === 'string') {
    el = document.querySelector(target);
  }

  if (!el) {
    return null;
  }

  if (scroll && typeof el.scrollIntoView === 'function') {
    try {
      el.scrollIntoView({
        block: 'center',
        inline: 'center',
        behavior: 'smooth',
      });
    } catch {
      el.scrollIntoView();
    }
  }

  try {
    el.focus({ preventScroll: !scroll });
  } catch {
    el.focus();
  }

  return el;
}
